<p-dialog
  [header]="titleKey | abpLocalization"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="inbound-number-form">
  <form [formGroup]="form" class="d-flex flex-column gap-3" novalidate>
    <div>
      <label for="inbound-phone" class="form-label indicates-required-field">
        {{ 'Settings::PhoneNumbers:PhoneNumber' | abpLocalization }}
      </label>
      <input
        pInputText
        id="inbound-phone"
        type="text"
        inputmode="tel"
        formControlName="phoneNumber"
        [skipValidation]="true"
        [placeholder]="phoneNumberPlaceholder"
        class="form-control" />
      @if (
        form.get('phoneNumber')?.invalid &&
        (form.get('phoneNumber')?.dirty || form.get('phoneNumber')?.touched)
      ) {
        <div class="text-danger small mt-1">
          @if (form.get('phoneNumber')?.errors?.['required']) {
            {{ 'Settings::PhoneNumbers:PhoneNumberRequired' | abpLocalization }}
          } @else if (form.get('phoneNumber')?.errors?.['pattern']) {
            {{ 'Settings::PhoneNumbers:PhoneNumberInvalidFormat' | abpLocalization }}
          }
        </div>
      }
    </div>

    <div class="row g-3">
      <div class="col-12 col-sm-6">
        <label class="form-label indicates-required-field">
          {{ 'Settings::PhoneNumbers:Provider' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="provider"
          [options]="providerOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Settings::PhoneNumbers:SelectProvider' | abpLocalization"
          appendTo="body" />
      </div>

      <div class="col-12 col-sm-6">
        <label class="form-label indicates-required-field">
          {{ 'Settings::PhoneNumbers:RoutingType' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="routingType"
          [options]="routingOptions"
          optionLabel="label"
          optionValue="value"
          optionDisabled="disabled"
          appendTo="body" />
      </div>
    </div>

    <div>
      <label class="form-label indicates-required-field">
        {{ 'Settings::PhoneNumbers:IvrInstance' | abpLocalization }}
      </label>
      <cx-select
        class="w-100"
        formControlName="ivrInstanceId"
        [options]="ivrInstances"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'Settings::PhoneNumbers:SelectIvrInstance' | abpLocalization"
        [filter]="true"
        appendTo="body" />
    </div>

    @if (hasIvrInstanceSelected) {
      <div>
        <label for="inbound-ext" class="form-label">
          {{ 'Settings::PhoneNumbers:IvrExtension' | abpLocalization }}
        </label>
        <input
          pInputText
          id="inbound-ext"
          type="text"
          [value]="ivrExtensionDisplay"
          readonly
          class="form-control font-monospace text-body-secondary" />
        @if (!isEdit) {
          <small class="text-body-secondary d-block mt-1">
            {{ 'Settings::PhoneNumbers:IvrExtensionWillBeGenerated' | abpLocalization }}
          </small>
        }
      </div>
    }
  </form>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
        {{ 'Settings::PhoneNumbers:Cancel' | abpLocalization }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        [disabled]="submitting || form.invalid"
        (click)="submit()">
        {{ submitLabelKey | abpLocalization }}
      </button>
    </div>
  </ng-template>
</p-dialog>
